<h2 class="content-block">AoD Home</h2>
<div class="content-block">
  <div class="dx-card responsive-paddings" *ngIf="homePageData">
    <h4 class="ap-green home-sub-heading">Merchant</h4>
    <div class="logos-container">
      <p class="welcome-message" [innerHTML]="homePageData.merchantMessage"></p>
      <p class="welcome-message" [innerHTML]="homePageData.merchantContacts"></p>
    </div>
    <h4 class="ap-green home-sub-heading">Tonnage</h4>
    <p class="welcome-message" [innerHTML]="homePageData.tonnageMessage"></p>
    <p class="welcome-message" [innerHTML]="homePageData.tonnageContacts"></p>
  </div>
</div>
<dx-load-panel #dxLoadPanel shadingColor="rgba(0,0,0,0.4)" [visible]="isLoadPanelVisible" [showPane]="true"
  [shading]="false" [closeOnOutsideClick]="false">
</dx-load-panel>